import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import request from "../utils/request";

function Calendly() {
  const [stripeLoading, setStripeLoading] = useState(false);
  const [showStripeLink, setShowStripeLink] = useState(false);

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://assets.calendly.com/assets/external/widget.js"]'
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const updateOnboarding = async () => {
    try {
      await request.post("/hosts/onboardingbooked-status");
      setShowStripeLink(true);
    } catch (err) {
      console.error("Error updating onboarding status", err);
    }
  };

  useEffect(() => {
    updateOnboarding();
  }, []);

  const handleStripeClick = async () => {
    setStripeLoading(true);
    try {
      const { data } = await request.get("/stripe/get-onboarding-link");
      window.location.href = data.url;
    } catch (error) {
      console.error("Error getting Stripe onboarding link:", error);
    }
    setStripeLoading(false);
  };

  return (
    <div className="space-y-6">
      <div className="overflow-hidden rounded-2xl border border-gray-200/60 bg-white shadow-sm">
        <div
          className="calendly-inline-widget"
          data-url="https://calendly.com/alex-bellhopt"
          style={{ minWidth: "320px", height: "580px" }}
        />
      </div>

      {showStripeLink && (
        <div className="flex flex-col items-center gap-3 rounded-2xl border border-green-200/60 bg-gradient-to-r from-green-50 to-emerald-50 p-5">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 shadow-md shadow-green-500/25">
              <svg className="h-5 w-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">Ready to start earning?</p>
              <p className="text-xs text-gray-500">Connect your Stripe account to receive payouts</p>
            </div>
          </div>
          <button
            onClick={handleStripeClick}
            disabled={stripeLoading}
            className="w-full rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-green-500/25 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60"
          >
            {stripeLoading ? <CircularProgress color="inherit" size={20} /> : "Link Stripe Account"}
          </button>
        </div>
      )}
    </div>
  );
}

export default Calendly;
